var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBuildings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.57 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.07,10.5h-4V1.5c0-.83-.67-1.5-1.5-1.5h-7c-.83,0-1.5.67-1.5,1.5v3h-4c-.83,0-1.5.67-1.5,1.5v2.02h1.5v-2.02h4v13.5h-1.56v1.5h1.56s8.5,0,8.5,0h7v-9c0-.83-.67-1.5-1.5-1.5ZM15.57,19.5h-7V4.5h0V1.5h7v18ZM21.07,19.5h-4v-7.5h4v7.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.79,
    y: 4.21,
    width: 1.5,
    height: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.84,
    y: 4.21,
    width: 1.5,
    height: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.79,
    y: 9,
    width: 1.5,
    height: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.84,
    y: 9,
    width: 1.5,
    height: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.79,
    y: 13.79,
    width: 1.5,
    height: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.84,
    y: 13.79,
    width: 1.5,
    height: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49,15.19c.39-2.56-2.42-4.99-2.75-5.26l-.48-.4-.48.4c-.32.27-3.14,2.71-2.75,5.26.18,1.19,1.02,2.15,2.48,2.86v4.45h1.5v-4.45c1.46-.71,2.29-1.67,2.48-2.86ZM1.52,14.96c-.18-1.19.94-2.63,1.74-3.44.8.81,1.93,2.25,1.74,3.44-.08.51-.42.96-.99,1.36v-2.72h-1.5v2.72c-.58-.4-.92-.85-.99-1.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuildings);
export default __webpack_public_path__ + "static/media/ic-buildings.bb9b32d71068f6dee94e96e26acc9a76.svg";
export { ForwardRef as ReactComponent };